export default __webpack_public_path__ + "static/media/map-pin.5a9a7adb.svg";